export const fathomEvent = (eventID, eventValue = 0) => {
    if (eventID) {
        try {
            fathom.trackGoal(eventID, eventValue);
        } catch {
            console.warn(`Fathom script was not found, unable to process event for: ${eventID}`)
        }
    }
}
